<template>
	<div class="prod_info" v-if="obj_to_null(this.product)">

		<div class="text-center" v-if="this.product.hasOwnProperty('main_photo')">
			<picture>
				<source :srcset="product.main_photo.webp" type="image/webp">
				<source :srcset="product.main_photo.jpeg" type="image/jpeg">
				<img itemprop="image" :src="product.main_photo.jpeg" style="max-width: 350px">
			</picture>
		</div>

        <info_field f_uniq="ct"
                    f_type="title"
                    @update_categ="change_atr"
                    :f_title="__t('NAME')"
                    :is_disabled="is_disabled"
                    :f_val="product.title">
        </info_field>

        <div class="form-group mt-2">
            <label class="form-label" for="description">
                {{ __t('INTRO_PROD') }}
            </label>

            <div class="input-group flex-nowrap">
                <div class="input-group-prepend">
						<span class="input-group-text">
							<i class="fal  fa-typewriter fs-xl" ></i>
						</span>
                </div>
                <textarea id="description" type="text" class="form-control" v-model="product.content"></textarea>
            </div>
        </div>

        <div class="pt-2 pb-2">


            <h5 class="frame-heading">{{__t("CATEG_TAG_PUBLISH")}}</h5>
            <div class="custom-control custom-checkbox custom-control-inline">
                <input type="checkbox" v-model="product.published" class="custom-control-input" id="publish">
                <label class="custom-control-label" for="publish">{{__t("PUBLISHED_TTL")}}</label>
            </div>
        </div>
		<info_field f_uniq="cid" :f_title="__t('UNIQ_PROV_CODE')" :f_val="product.uniq_id.toString()"></info_field>
		<info_field  f_uniq="cuid" :f_title="__t('UNIQ_GO_CODE')" :f_val="product.id"></info_field>
        <info_field  f_uniq="cuid" :f_title="__t('GO_PROD_TYPE')" :f_val="product.go_type"></info_field>


		<info_field :f_title="__t('LOAD_FROM')" f_icon="fa-sync" :f_val="prov_name"></info_field>
	</div>
</template>

<script>
import Info_field from "../../../../sys/info_field";
export default {
	name: "product_info",
	components: {Info_field},
	props : {
		product : {
			type : Object
		}
	},
    methods :  {
        change_atr(atr_name,atr_val) {
            if(this.product.hasOwnProperty(atr_name)) {
                this.product[atr_name] = atr_val;
            }
        }
    },
    computed : {
        is_disabled () {
            return this.product.id > 0 && parseInt(this.product.provider_id) != 8;
        },

        prov_name() {
            if(this.product.hasOwnProperty("provider")) {
                return this.product.provider.name + " <-- " + this.product.provider.direction;
            }
        }
    },

}
</script>

<style scoped>

</style>
